export default "__VITE_ASSET__DtGRW54F__"